/* eslint-disable max-len */
import React, { Component } from 'react';
import Card from 'antd/es/card/Card';
import Paragraph from 'antd/es/typography/Paragraph';
import Title from 'antd/es/typography/Title';
import Avatar from 'antd/lib/avatar';
import Col from 'antd/lib/col';
import Flex from 'antd/lib/flex';
import Row from 'antd/lib/row';
import { Link } from 'react-router-dom';
import routesConfig from '../../../config/routes';

const games = [
  {
    id: 'rps',
    title: 'Камень, ножницы, бумага',
    body: 'Эта, казалось бы, простая игра, имеет древнюю историю, восходящую к Китаю времён династии Хань. Тогда она называлась "Джао-Цзюнь" и использовалась для решения споров между воинами и учёными. Камень символизировал силу гор, ножницы — острый ум, а бумага — мудрость, способную охватить всё. Даже в наше время игра остаётся не только развлечением, но и символом философии баланса.',
    image: '/images/rps-game.png',
    link: routesConfig.gameKnb,
  },
  {
    id: 'hot',
    title: 'Орел и решка',
    body: 'Эта древнейшая игра уходит корнями в Римскую империю, где монеты использовали для принятия решений наравне с жребием. Монета подбрасывается вверх, и участники предугадывают, упадёт ли она орлом — символом побед и власти, или решкой, напоминающей простоту повседневной жизни. В современности игра стала символом чистого случая, ведь, как говорили римляне, "Alea iacta est" — жребий брошен.',
    image: '/images/hot-game.png',
    link: routesConfig.gameHot,
  },
  {
    id: 'gtn',
    title: 'Угадай число',
    body: 'Игра для истинных мыслителей, напоминающая логические загадки средневековых математиков. Один из участников загадывает число от 1 до 3, а другой пытается его угадать, опираясь лишь на интуицию и своё чутьё. Напоминает загадки, которые задавали в древнегреческих академиях: попробуй разгадать тайну, не имея подсказок, как будто разговариваешь с самим Пифагором.',
    image: '/images/gtn-game.jpg',
    link: routesConfig.home,
  },
  {
    id: 'ms',
    title: 'Сапёр',
    body: 'Эта игра, вдохновлённая работой сапёров времён Второй мировой войны, требует стратегического мышления и аналитического подхода. Игрок открывает клетки, избегая мин, полагаясь на подсказки в виде чисел. Каждое успешное открытие клетки — как шаг к победе в великой битве. Сапёр — не просто игра, а тренировка ума и умение находить порядок в хаосе.',
    image: '/images/ms-game.png',
    link: routesConfig.home,
  },
];

interface IProps {
  isAuth?: boolean;
}

class _GamesIntro extends Component<IProps> {
  render(): React.ReactNode {
    return (
      <Row gutter={[32, 32]} style={{ marginTop: 16 }}>
        {games.map(item => (
          <Col xs={24} sm={12} key={item.id}>
            <Link to={this.props.isAuth ? item.link : routesConfig.home}>
              <Card hoverable>
                <Flex justify="center" style={{ marginBottom: 20, marginTop: 20 }}>
                  <Avatar size={200} shape="square" src={item.image} />
                </Flex>
                <Title level={5}>{item.title}</Title>
                <Paragraph>{item.body}</Paragraph>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
    );
  }
}

export const GamesIntro = _GamesIntro;
